<form [formGroup]="loginForm" [@demoAnimation]="{
    value: '',
    params: {
      from: (lastFormTracker | async) === 'ACCESSCODE' ? '40%' : '-40%'
    }
  }">
  <mat-form-field class="w-full" appearance="fill">
    <mat-label>{{ "page.login.form.login.usernameField.label" | translate }}</mat-label>
    <input matInput noWhiteSpace="WIPE" id="txtLoginUserName" type="text" name="username" [maxlength]="10"
      placeholder="{{ 'page.login.form.login.usernameField.label' | translate }}" formControlName="userID" />
    <mat-error *ngIf="loginForm.get('userID')?.hasError('required')">{{
      "page.login.form.login.usernameField.requiredMessage" | translate }}</mat-error>
    <mat-error
      *ngIf="loginForm.get('userID')?.hasError('maxLength') || loginForm.get('userID')?.hasError('invalidLength')">
      {{ "page.login.form.login.usernameField.invalidLengthMessage" | translate }}
    </mat-error>
  </mat-form-field>
  <div class="forgot-link">
    <button class="mobileHide" type="button" name="forgot-password-button" id="btnFotgotPassword"
      (click)="showuseridRecoveryForm()" *ngIf="productVer === 'true'">
      {{ "page.login.form.login.forgotUserIdButton" | translate }}
    </button>
  </div>

  <mat-form-field class="w-full" appearance="fill">
    <mat-label>{{ "page.login.form.login.passwordField.label" | translate }}</mat-label>
    <input matInput id="txtLoginPwd" [type]="(hidePassword) ? 'password' : 'text'" name="password" [maxLength]="20"
      placeholder="{{ 'page.login.form.login.passwordField.label' | translate }}" formControlName="password" />
    <i class="fa-regular showPasswordIcon" [ngClass]="toggleIcon" (click)="togglePasswordDisplay()"></i>
    <mat-error *ngIf="loginForm.get('password')?.hasError('required')">{{
      "page.login.form.login.passwordField.requiredMessage" | translate }}</mat-error>
  </mat-form-field>

  <div class="forgot-link FrgtPasswd">
    <button class="mobileHide" type="button" name="forgot-password-button" id="btnFotgotPassword"
      (click)="showPasswordRecoveryForm()">
      {{ "page.login.form.login.forgotPasswordButton" | translate }}
    </button>
  </div>

  <div class="NotRobot_Captcha_Main" *ngIf="this.attemptsLeft === 1 || this.attemptsLeft === 2">

    <!-- "I'm not a robot" Checkbox - Only visible when attempts are limited -->
    <div class="NotRobot_Captcha">
      <mat-checkbox formControlName="NotRobotCheckbox" [checked]="isNotRobotChecked"
        (change)="onNotRobotCheckboxChange($event.checked)" color="primary">
        I'm not a robot
      </mat-checkbox>
    </div>
    <div>
      <!-- CAPTCHA Section - Only visible when checkbox is checked -->
      <div class="NotRobot_Captcha_Wrap" *ngIf="showCaptcha">
        <p class="TitleText">Please complete the CAPTCHA below: <span class="ImpField">*</span></p>
        <mat-form-field appearance="fill">
          <input matInput formControlName="Captcha" placeholder="Enter CAPTCHA" name="captchaInput" maxlength="6"
            autocomplete="off" />
          <div class="captcha-box" matSuffix>
            <div class="captcha-canvas"> <canvas #captchaCanvas width="160" height="40"></canvas> </div>
            <div class="captcha-controls">
              <button mat-icon-button type="button" (click)="generateCaptcha()"
                title="Refresh CAPTCHA"><mat-icon>refresh</mat-icon></button>
              <button mat-icon-button type="button" (click)="playAudio()"
                title="Audio CAPTCHA"><mat-icon>volume_up</mat-icon></button>
            </div>
          </div>
          <mat-error *ngIf="loginForm.get('Captcha')?.hasError('required')">
            {{ "CAPTCHA is required to continue." | translate }}

          </mat-error>
          <mat-error *ngIf="loginForm.get('Captcha')?.hasError('captchaMismatch')">
            {{ "CAPTCHA verification failed. Please try again." | translate }}

          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
  <!-- <div class="forgot-link">
    <button
      class="mobileHide"
      type="button"
      name="forgot-password-button"
      id="btnFotgotPassword"
      (click)="showPasswordRecoveryForm()"
    >
      {{ "page.login.form.login.forgotPasswordButton" | translate }}
    </button>
  </div> -->
  <p class="errorMessage"> {{ showerrorMessage }} </p>
  <div class="forgotButton">
    <section class="example-section">
      <kendo-label class="KeepMeLoggedin" text="{{ 'page.login.form.login.rememberLoginOption.label' | translate }}">
        <kendo-switch id="swtRememberMe" size="small"
          [offLabel]="('page.login.form.login.rememberLoginOption.off' | translate)"
          [onLabel]="('page.login.form.login.rememberLoginOption.on' | translate)" formControlName="rememberMe"
          [disabled]="!formIsValid" (valueChange)="openTermsAndConditionsDialog($event)"></kendo-switch>
      </kendo-label>
    </section>
    <!-- <button
      class="mobileHide"
      type="button"
      name="forgot-password-button"
      id="btnFotgotPassword"
      (click)="showPasswordRecoveryForm()"
    >
      {{ "page.login.form.login.forgotPasswordButton" | translate }}
    </button> -->
  </div>
  <div class="BtnWrapper">
    <button type="submit" *ngIf="productVer === 'true'" kendoButton id="btnLogin" color="primary" name="login-button"
      id="btnSubmit" [disabled]="!formIsValid" (click)="checkForMFA()">
      {{ "page.login.form.login.loginButton" | translate }}
    </button>
    <button type="submit" *ngIf="productVer === 'false'" kendoButton id="btnLogin" color="primary" name="login-button"
      id="btnSubmit" [disabled]="!formIsValid" (click)="loginOld()">
      {{ "page.login.form.login.loginButton" | translate }}
    </button>
  </div>
  <div class="MobileForgotButton">
    <button *ngIf="productVer === 'true'" class="mobileShow" type="button" name="forgot-password-button"
      id="btnFotgotPassword" (click)="showuseridRecoveryForm()">
      {{ "page.login.form.login.forgotUserIdButton" | translate }}
    </button>
    <button id="lnkForgotPwd" class="mobileShow" name="forgot-password-button" (click)="showPasswordRecoveryForm()">
      {{ "page.login.form.login.forgotPasswordButton" | translate }}
    </button>
  </div>
</form>